import './Home.scss';
import { OwnerImages, offices, picto } from '../../assets/data';
import { useOffice } from '../../utils/hooks/hooks';

import HeroSection from '../../components/HeroSection/HeroSection';
import PhotoArticle from '../../components/PhotoArticle/PhotoArticle';
import Card from '../../components/Card/Card';
import Offices from '../../components/Buttons/Offices';
import TextCarrousel from '../../components/TextCarrousel/TextCarrousel';
import Collapse from '../../components/Collapse/Collapse';
import LinkButton from '../../components/Buttons/LinkButton';
import InfoButton from '../../components/Buttons/InfoButton';

function Home() {
     const ProfilImage = OwnerImages.find((img) => img.type === 'profil');
     const { selectedOffice } = useOffice();
     const selectedOfficeData = offices.find(
          (office) => office.id === selectedOffice
     );

     return (
          <>
               <main id="accueil" className="home__main">
                    <HeroSection
                         url={selectedOfficeData.heroSectionSrc}
                         link={selectedOfficeData.heroSectionPhotoLink}
                         author={selectedOfficeData.heroSectionPhotoAuthor}
                         backgroundColor="rgb(2, 65, 64)"
                    >
                         <div className="title index">
                              <h1>Simon LESECQ</h1>
                              <h2>Ostéopathe D.O.</h2>
                         </div>

                         <Offices offices={offices} num="1" type="light" />

                         <div className="phone">
                              <a
                                   className="phone__number"
                                   href="tel:0685479237"
                              >
                                   06 85 47 92 37
                              </a>
                         </div>

                         <div className="link-container">
                              <LinkButton
                                   type="light"
                                   link={selectedOfficeData.doctolibLink}
                              >
                                   <span>Prendre RDV</span>
                                   <i className="fa-solid fa-calendar-days"></i>
                              </LinkButton>
                              <LinkButton
                                   type="light"
                                   link={selectedOfficeData.googleMapLink}
                              >
                                   <span>Itinéraire</span>
                                   <i className="fa-sharp fa-solid fa-map-location-dot"></i>
                              </LinkButton>
                         </div>
                    </HeroSection>
                    <section>
                         <article>
                              <div className="article__container">
                                   <PhotoArticle side="right" url={ProfilImage}>
                                        <>
                                             <p className="indent">
                                                  <strong>
                                                       Ostéopathe D.O. depuis
                                                       2011
                                                  </strong>
                                                  , diplômé de l’Institut
                                                  Supérieur d’Ostéopathie de
                                                  Lille, j’exerce au sein d’un
                                                  cabinet pluridisciplinaire
                                                  dans la métropole lilloise
                                                  ainsi qu’à Dunkerque.
                                             </p>
                                             <p>
                                                  Mon approche est globale,
                                                  fonctionnelle et centrée sur
                                                  le patient, avec une solide
                                                  expérience du travail
                                                  pluridisciplinaire aux côtés
                                                  de kinésithérapeutes,
                                                  podologues, orthoptistes, et
                                                  préparateurs physiques. La
                                                  construction d’une synergie
                                                  thérapeutique est au cœur de
                                                  ma pratique.
                                             </p>
                                             <p>
                                                  Grâce à une maîtrise des
                                                  différentes approches
                                                  ostéopathiques, je suis en
                                                  mesure de m’adapter aux
                                                  particularités de chaque
                                                  patient et de proposer les
                                                  soins les plus appropriés. De
                                                  plus, mes connaissances
                                                  médicales me permettent
                                                  d’orienter mes patients vers
                                                  les professionnels de santé
                                                  adéquats lorsque cela sort de
                                                  mon domaine de compétence,
                                                  évitant ainsi les pertes de
                                                  temps et les traitements
                                                  inadaptés.
                                             </p>
                                             <p>
                                                  Particulièrement sensible à la
                                                  prise en charge des sportifs,
                                                  je m’efforce de développer
                                                  continuellement la qualité de
                                                  mes soins dans ce domaine,
                                                  tout en restant attentif aux
                                                  autres aspects de ma
                                                  profession. Mon objectif est
                                                  d’offrir une prise en charge
                                                  adaptée et personnalisée à
                                                  chaque patient.
                                             </p>
                                             <p>
                                                  En parallèle, je suis{' '}
                                                  <strong>enseignant</strong> au
                                                  sein de l’Institut Supérieur
                                                  d’Ostéopathie de Lille. Cette
                                                  activité me permet de
                                                  transmettre mes connaissances
                                                  tout en enrichissant
                                                  constamment ma pratique.
                                             </p>
                                             <p>
                                                  Si vous souhaitez en savoir
                                                  plus ou discuter d’une prise
                                                  en charge, n’hésitez pas à me
                                                  contacter, je serai ravi de
                                                  répondre à vos questions et au
                                                  plaisir de vous recevoir.
                                             </p>
                                             <LinkButton
                                                  type="secondary"
                                                  size="large"
                                                  link={
                                                       selectedOfficeData.doctolibLink
                                                  }
                                             >
                                                  <span>
                                                       RDV avec Simon Lesecq
                                                  </span>
                                                  <i className="fa-solid fa-calendar-days"></i>
                                             </LinkButton>
                                        </>
                                   </PhotoArticle>
                                   <div className="cards">
                                        <h3>
                                             À coté du cabinet, j'ai d'autres
                                             activités :
                                        </h3>
                                        <div className="cards__container container--80vw">
                                             <Card
                                                  // title="Ma pratique"
                                                  picto={picto[0]}
                                             >
                                                  <p>
                                                       Enseignant et maître de
                                                       stage à{' '}
                                                       <span className="nowrap">
                                                            l'Inso Lille
                                                       </span>
                                                  </p>
                                             </Card>
                                             <Card
                                                  // title="Prise en charge"
                                                  picto={picto[1]}
                                             >
                                                  <p>
                                                       Je suis l'ostéopathe de
                                                       l'équipes pro de{' '}
                                                       <span className="nowrap">
                                                            l'USDK handball
                                                       </span>
                                                  </p>
                                             </Card>
                                             <Card
                                                  // title="Collaboration"
                                                  picto={picto[2]}
                                                  // message={picto[2].message}
                                             >
                                                  <p>
                                                       Lucie, mon assistante,
                                                       rejoint le cabinet
                                                  </p>
                                                  <LinkButton
                                                       type="secondary"
                                                       size="large"
                                                       link="https://www.doctolib.fr/osteopathe/marcq-en-baroeul/lucie-breuilles-marcq-en-baroeul"
                                                  >
                                                       <span>
                                                            RDV avec Lucie
                                                       </span>
                                                       <i className="fa-solid fa-calendar-days"></i>
                                                  </LinkButton>
                                             </Card>
                                        </div>

                                        <div className="info__button-position">
                                             <InfoButton side="left">
                                                  <p>
                                                       icons created by{' '}
                                                       <a
                                                            href={
                                                                 picto[0].author
                                                            }
                                                       >
                                                            {picto[0].message}
                                                       </a>
                                                       {', '}
                                                       <a
                                                            href={
                                                                 picto[1].author
                                                            }
                                                       >
                                                            {picto[1].message}
                                                       </a>
                                                       {' and '}
                                                       <a
                                                            href={
                                                                 picto[2].author
                                                            }
                                                       >
                                                            {picto[2].message}
                                                       </a>
                                                       - Flaticon
                                                  </p>
                                             </InfoButton>
                                        </div>
                                   </div>
                              </div>
                         </article>
                         <article id="questions" className="index">
                              <div className="article__container container--80vw">
                                   <h2>Questions Fréquentes</h2>
                                   <p>
                                        Je réponds aux interrogations qui
                                        pourraient survenir avant votre
                                        consultation. Si, malgré cela, vous ne
                                        parvenez pas à trouver les informations
                                        que vous cherchez, n'hésitez pas à me
                                        les communiquer à travers le formulaire
                                        de contact.
                                   </p>
                                   <Collapse title="Comment se déroule une consultation ?">
                                        <p>
                                             La séance dure en moyenne 45
                                             minutes, et s'organise en 3 temps :
                                             l'entretien, l'examen clinique et
                                             le traitement ostéopathique.
                                        </p>
                                   </Collapse>
                                   <Collapse title="Quelle tenue est conseillée pour la séance?">
                                        <p>
                                             La prise en charge repose sur le
                                             mouvement du corps, vous serez donc
                                             amené(e) à vous mettre en
                                             sous-vêtements ou en vêtements fins
                                             près du coprs (leggings et/ou
                                             brassière ). L'essentiel est de se
                                             sentir à l'aise dans sa tenue lors
                                             de la consultation.
                                        </p>
                                   </Collapse>
                                   <Collapse title="Existe-t-il une prise en charge Sécurité Sociale ?">
                                        <p>
                                             L’ostéopathie n’est pas remboursée
                                             par la Sécurité Sociale. Cependant,
                                             de nombreuses mutuelles remboursent
                                             une à plusieurs séances par an.
                                        </p>
                                   </Collapse>
                                   <Collapse title="Quelles sont mes expériences ?">
                                        <ul>
                                             <li>
                                                  Praticien libéral -
                                                  Marcq-en-Barœul - Wasquehal -
                                                  Dunkerque (depuis 2011){' '}
                                             </li>
                                             <li>
                                                  Ostéopathe de l'équipe
                                                  professionnelle de Handball
                                                  USDK
                                             </li>
                                             <li>
                                                  Enseignant et maître de stage
                                                  à l'Institut Supérieur
                                                  d'Ostéopathie (InSO) - Lille
                                             </li>
                                             <li>
                                                  Enseignant vacataire D.U.
                                                  Podologie du sport (FSSEP) -
                                                  Lille
                                             </li>
                                        </ul>
                                   </Collapse>
                              </div>
                         </article>
                         <article id="tarif" className="index">
                              <div className="container--80vw">
                                   <div className="two-column__container container equal-column">
                                        <div>
                                             <h2>Tarifs</h2>
                                             <p className="subtitle">
                                                  60€ la consultation
                                             </p>
                                        </div>
                                        <div className="thin-separator-line">
                                             <p>
                                                  Ces honoraires vous sont
                                                  communiqués à titre indicatif
                                                  par le praticien. Ils peuvent
                                                  varier selon le lieu de prise
                                                  en charge.
                                             </p>
                                             <p>
                                                  Remboursement : 85% des
                                                  mutuelles remboursent une à
                                                  plusieurs séances
                                                  d’ostéopathie par années.
                                                  Votre praticien pourra vous
                                                  délivrer une facture par mail,
                                                  à renseigner à votre mutuelle.
                                             </p>
                                             <LinkButton
                                                  type="secondary"
                                                  size="large"
                                                  link={
                                                       selectedOfficeData.doctolibLink
                                                  }
                                             >
                                                  <span>
                                                       Prendre Rendez-vous
                                                  </span>
                                                  <i className="fa-solid fa-calendar-days"></i>
                                             </LinkButton>
                                        </div>
                                   </div>
                                   <div className="picture-office__container">
                                        {offices
                                             .find(
                                                  (office) =>
                                                       office.id ===
                                                       selectedOffice
                                             )
                                             .images?.map((image, index) => (
                                                  <img
                                                       key={`image_${index}`}
                                                       alt=""
                                                       src={image.src}
                                                       srcSet={image.srcset}
                                                  />
                                             ))}
                                   </div>
                              </div>
                         </article>
                         <article id="contact" className="index">
                              <div className="two-column__container equal-column">
                                   <div className="map__container">
                                        <iframe
                                             src={
                                                  selectedOfficeData.googleMapIFrameLink
                                             }
                                             width="600"
                                             title="office"
                                             allowFullScreen=""
                                             loading="lazy"
                                             referrerPolicy="no-referrer-when-downgrade"
                                             style={{
                                                  border: '2px solid rgb(2,65,64)',
                                             }}
                                        ></iframe>
                                   </div>
                                   <div className="contact__container">
                                        <h2>Contact</h2>
                                        <h3>Simon Lesecq</h3>
                                        <Offices
                                             offices={offices}
                                             num="2"
                                             type="dark"
                                        />
                                   </div>
                              </div>
                         </article>
                         <article id="pour_qui" className="index">
                              <div className="container--80vw-bigScreen">
                                   <h2>Pour Qui ?</h2>
                                   <div className="two-column__container one-third-two-third-column">
                                        <div className="textCarrousel__text__container">
                                             <h3>
                                                  En quoi est ce que
                                                  l'ostéopathie peut vous aider
                                                  ?
                                             </h3>
                                             <p>
                                                  L’ostéopathie, une approche
                                                  globale de bien-être, allie
                                                  une expertise clinique et des
                                                  techniques manuelles du
                                                  système musculo-squelettique
                                                  et de relâchement myofascial
                                                  pour vous libérer de vos maux.
                                             </p>
                                        </div>
                                        <TextCarrousel>
                                             <div className="textCarrousel__text__container">
                                                  <h3>Douleur lombaire</h3>
                                                  <p>
                                                       La douleur lombaire,
                                                       souvent ressentie dans la
                                                       partie inférieure du dos,
                                                       peut avoir des origines
                                                       diverses, allant du
                                                       stress musculaires à des
                                                       dysfonctions articulaires
                                                       ou nerveuses.{' '}
                                                  </p>
                                                  <p>
                                                       Les interventions visent
                                                       à restaurer l'équilibre
                                                       musculo-squelettique, à
                                                       améliorer la mobilité
                                                       articulaire et soulager
                                                       les tensions musculaires.
                                                  </p>
                                             </div>
                                             <div className="textCarrousel__text__container">
                                                  <h3>Douleurs neurogènes</h3>
                                                  <p>
                                                       Sciatique, cruralgie,
                                                       névralgie
                                                       cervico-brachiale,
                                                       syndrome du canal
                                                       carpein. L'ostéopathie
                                                       peut être complémentaire
                                                       à d'autres approches
                                                       médicales et être
                                                       bénéfique dans la gestion
                                                       de la douleur neurogène.
                                                  </p>
                                             </div>
                                             <div className="textCarrousel__text__container">
                                                  <h3>Troubles digestifs</h3>
                                                  <p>
                                                       Brûlures d'estomac,
                                                       diarrhées, constipations,
                                                       ballonements sont des
                                                       motifs de consultations
                                                       courants. Votre
                                                       ostéopathe identifiera
                                                       les facteurs impliqués,
                                                       atténuera ces troubles à
                                                       l'aide de techniques
                                                       manuelles douces et vous
                                                       réorientera vers le bon
                                                       professionnel si
                                                       nécéssaire
                                                  </p>
                                             </div>
                                             <div className="textCarrousel__text__container">
                                                  <h3>Sport et traumatismes</h3>
                                                  <p>
                                                       Course à pied, natation,
                                                       handball, triathlon,
                                                       crossfit, l'ostéopathie
                                                       offre une approche
                                                       complémentaire dans la
                                                       démarche
                                                       pluridisciplinaire de
                                                       prise en charge (kiné,
                                                       medecin du sport...).
                                                       Elle aide à reprendre une
                                                       activité correctement,
                                                       traite les douleurs,
                                                       optimise et améliore la
                                                       récupération (entorses,
                                                       tendinites, douleurs
                                                       lombaires)
                                                  </p>
                                             </div>
                                        </TextCarrousel>
                                   </div>
                              </div>
                         </article>
                    </section>
               </main>
          </>
     );
}

export default Home;
